import { mergeQueryKeys } from '@lukemorales/query-key-factory';

import { users } from '@api/users';

import { legalEntities } from './actors';
import { application, applicationEditors } from './applications';
import { auth } from './auth';
import { externalServices } from './externalServices';
import { files } from './files';
import { funds } from './funds';
import { urls } from './urls';

export const queries = mergeQueryKeys(
  application,
  applicationEditors,
  auth,
  externalServices,
  files,
  funds,
  legalEntities,
  urls,
  users,
);
